import { addressFormSchema } from '@/components/blocks/AddressForm/addressFormSchema';
import { ADDRESS_FORM_IDS } from '@/components/blocks/AddressForm/constants';
import { FieldTooltipTopRight } from '@/components/blocks/AddressForm/parts/FieldTooltipTopRight';
import { AAFieldItemSX } from '@/components/blocks/AddressForm/styles/formFields';
import {
	onBeforeInputNumeric,
	onDropNumeric,
	onPasteNumeric,
	validateNumericInput,
} from '@/components/blocks/AddressForm/utils';
import { EMarketingSpot } from '@/components/content/EMarketingSpot';
import { useLocalization } from '@/data/Localization';
import { TextField } from '@mui/material';
import { ChangeEvent, FC } from 'react';
import { NO_EXTERIOR_NUMBER_LABEL } from 'shared/custom/utils/exteriorNumber';

const EXTERIOR_NUMBER_TOOLTIP_ESPOT = 'Checkout_DeliveryDetail_AddressForm-Tooltip';

type Props = {
	value: string;
	isNoExteriorNumberChecked: boolean;
	error: boolean;
	helperText: string;
	onChange: (event: ChangeEvent<HTMLInputElement>) => void;
	onBlur: () => void;
};

export const ExteriorNumberField: FC<Props> = ({
	value,
	isNoExteriorNumberChecked,
	error,
	helperText,
	onChange,
	onBlur,
}) => {
	const addressFormNLS = useLocalization('AddressForm');

	return (
		<TextField
			id={ADDRESS_FORM_IDS.exteriorNumberInput}
			data-testid="address-form-address-line2"
			name="addressLine2"
			size="small"
			inputMode="numeric"
			label={addressFormNLS.Labels.ExteriorNumber.t()}
			value={isNoExteriorNumberChecked ? NO_EXTERIOR_NUMBER_LABEL : value}
			disabled={isNoExteriorNumberChecked}
			inputProps={{ ...addressFormSchema.exteriorNumber, readOnly: isNoExteriorNumberChecked }}
			onChange={onChange}
			onBlur={onBlur}
			error={error}
			helperText={helperText}
			fullWidth
			autoComplete="address-extNum"
			sx={AAFieldItemSX}
			onKeyDown={validateNumericInput}
			onBeforeInput={onBeforeInputNumeric}
			onPaste={onPasteNumeric}
			onDrop={onDropNumeric}
			InputProps={{
				endAdornment: isNoExteriorNumberChecked ? null : (
					<FieldTooltipTopRight
						id={ADDRESS_FORM_IDS.exteriorNumberTooltip}
						content={
							<EMarketingSpot
								id={EXTERIOR_NUMBER_TOOLTIP_ESPOT}
								properties={{ emsName: EXTERIOR_NUMBER_TOOLTIP_ESPOT }}
							/>
						}
					/>
				),
			}}
		/>
	);
};
